import localforage from 'localforage';

const storeCache = new Map();
const MAX_STORES = 15; // Higher limit for performance-first approach

export const getLocalForageStore = (name) => {
  if (!storeCache.has(name)) {
    // Clean up if we have too many stores (less aggressive now)
    if (storeCache.size >= MAX_STORES) {
      const oldestStore = storeCache.keys().next().value;
      storeCache.delete(oldestStore);
    }
    storeCache.set(name, localforage.createInstance({ name }));
  }
  return storeCache.get(name);
};